import Vue from "vue"
import VueRouter from "vue-router"
import routes from "./routes"

Vue.use(VueRouter)

// Setup vue-router
const router = new VueRouter({
    mode: "history",
    base: "/",
    routes,
    scrollBehavior: (to, from, savedPosition) => {
        if(!!to && !!to.meta && !!to.meta.scroll_position) {
            to.meta.scroll_position = savedPosition
            return savedPosition
        }
        return { x: 0, y: 0 }
    }
})
router.beforeEach((to, from, next) => {
    if(to.name.match(/^learn\./)) Vue.i18n.set("fr")
    next()
})

export default router
